module.exports = __webpack_public_path__ + "media/images/official/removeanxieties_icon_user-83b8c51a1609838db1259b9d575020af.svg";